import { Avatar } from "@mui/material";
import LocationIcon from "components/icons/LocationIcon";
import React from "react";
import * as S from "./index.styles";

interface FundraisingDetailMainProps {
  title: string;
  organizer: string;
  description: string;
  image: string;
  organizerAvatar: string;
  location?: string;
}

const FundraisingDetailMain: React.FC<FundraisingDetailMainProps> = ({
  title = "Untitled campaign",
  organizer = "Unknown organizer",
  description = "No description provided.",
  image = "https://via.placeholder.com/600x300?text=No+Image",
  organizerAvatar = "",
  location,
}) => {
  return (
    <S.MainSection>
      <S.HeaderSection>
        <S.Title>{title}</S.Title>
        {/*<S.SocialLinksContainer>
          <S.SocialIcon href="#" aria-label="Instagram">
            I
          </S.SocialIcon>
          <S.SocialIcon href="#" aria-label="Facebook">
            F
          </S.SocialIcon>
          <S.SocialIcon href="#" aria-label="Twitter">
            T
          </S.SocialIcon>
          <S.SocialIcon href="#" aria-label="Google">
            G
          </S.SocialIcon>
        </S.SocialLinksContainer>*/}
      </S.HeaderSection>
      <S.CoverImageContainer>
        <S.CoverImage src={image} alt={title} />
        <S.OrganizerText>
          <S.OrganizerInfo>
            <Avatar src={organizerAvatar} sx={{ width: 42, height: 42 }} />
            <S.OrganizerName>{organizer}</S.OrganizerName> is the fundraiser
          </S.OrganizerInfo>
          {location && (
            <S.LocationInfo>
              <LocationIcon />
              {location}
            </S.LocationInfo>
          )}
        </S.OrganizerText>
      </S.CoverImageContainer>
      <S.Description>{description}</S.Description>
    </S.MainSection>
  );
};

export default FundraisingDetailMain;
